import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { AiProviderKindsFetchedAction } from '@Application/Ai/AiProviderKinds/Actions/aiProviderKindsFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type AiProviderKindsStore = {
	aiProviderKinds: readonly LabeledValueView[] | null;
};

const initialState: AiProviderKindsStore = {
	aiProviderKinds: null,
};

type Actions = AiProviderKindsFetchedAction | UserRevokedAction;

const whenAiProviderKindsFetched = (
	store: AiProviderKindsStore,
	action: AiProviderKindsFetchedAction,
): AiProviderKindsStore => ({
	...store,
	aiProviderKinds: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): AiProviderKindsStore => initialState;

export default registerStore<'aiProviderKindsStore', Actions>(
	'aiProviderKindsStore',
	createSliceReducer({
		AI_PROVIDER_KINDS_FETCHED: whenAiProviderKindsFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
